import { Component, Inject, LOCALE_ID, OnInit } from "@angular/core";
import { UtilMasks } from "src/app/utils/util-masks";
import { FormGroup, FormControl } from "@angular/forms";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";
import { LaudoUnionService } from "src/app/services/http/laudo-union.service";
import { Router, ActivatedRoute } from "@angular/router";
import { LoginService } from "src/app/services/login.service";
import { first } from "rxjs/operators";
import { Usuario } from "src/app/models/usuario-login";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ModalEditarVistoriadorComponent } from "../modal-editar-vistoriador/modal-editar-vistoriador.component";
import { ModalMsgService } from "src/app/services/modal-msg.service";
import { ModalEditarDataVistoriaComponent } from "../modal-editar-data-vistoria/modal-editar-data-vistoria.component";
import { ExcelService } from "src/app/services/excel.service";
import { formatDate } from "@angular/common";

@Component({
  selector: 'app-list-laudos-agendados',
  templateUrl: './list-laudos-agendados.component.html',
  styleUrls: ['./list-laudos-agendados.component.scss']
})
export class ListLaudosAgendadosComponent implements OnInit {
  usuario: Usuario;
  tableLoading: boolean = false;
  listaResultado = [];
  total: number = 0;
  pesquisaDataInicio: any;
  pesquisaDataFim: any;

  laudoVisualizacao = null;

  masks = {
    data: { mask: UtilMasks.dataBr, guide: false },
    placa: { mask: UtilMasks.placa, guide: false },
  };

  form = new FormGroup({
    id: new FormControl(""),
    placa: new FormControl(""),
    nomeusuario: new FormControl(""),
    tipolaudo: new FormControl(""),
    status: new FormControl(""),
    cliente: new FormControl(""),
    unidade: new FormControl(""),
    dataRealizacaoInicio: new FormControl(""),
    dataRealizacaoFim: new FormControl(""),
  });

  params = {
    filter: {
      chassi: "",
      cliente: "",
      dataFim: new Date(),
      dataInicio: new Date(),
      id: "",
      placa: "",
      nomeusuario: "" ,
      status: "",
      tipoLaudo: "",
      unidade: "",
    },
    sorting: {
      id: "desc",
      nometipolaudo: "",
      nomecliente: "",
      nomeunidade: "",
      nomeusuario: "",
      placa: "",
      dataagendamento: "",
      local: "",
      dataultimaatualizacao: "",
      status: "",
    },
    data: new Date(),
    per_page: 10,
    page: 1,
  };

  listaTipoLaudo = [{ nome: "Selecione", id: "" }];
  listaClientes = [{ nomefantasia: "Selecione", id: "" }];
  listaUnidades = [{ nomefantasia: "Selecione", id: "" }];

  constructor(
    @Inject(LOCALE_ID) private locale: string,
    private excelService: ExcelService,
    private loginService: LoginService,
    private laudoUnionService: LaudoUnionService,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private modalMsgService: ModalMsgService,
  ) {
    let statusLaudo = this.route.snapshot.queryParams;
    if (statusLaudo && statusLaudo != null) {
      this.params.filter.status = <any>statusLaudo.status || "";
    }
    this.loginService
      .getLogIn()
      .pipe(first())
      .subscribe((u) => (this.usuario = u));
    this.laudoUnionService
      .getListaUnidades()
      .then((r) => (this.listaUnidades = this.listaUnidades.concat(r)));
    this.laudoUnionService
      .getListaClientes()
      .then((r) => (this.listaClientes = this.listaClientes.concat(r)));
    this.laudoUnionService
      .getListaTipoLaudo()
      .then((r) => (this.listaTipoLaudo = this.listaTipoLaudo.concat(r)));
  }

  ngOnInit() {
    this.params.filter.dataInicio.setDate(1);

    this.updateResult();

    this.form.valueChanges
      .pipe(distinctUntilChanged(), debounceTime(800))
      .subscribe((r) => {
        this.params.filter = { ...this.params.filter, ...r };
        // Verifica se existe ID, caso exista, transforma em String
        if (this.params.filter.id) {
          let id = this.params.filter.id.toString();
          this.params.filter.id = id;
        }
        this.updateResult();
      });
  }

  changeOrder() {
    this.updateResult();
  }

  setPageSize(size) {
    this.params.per_page = size;
    this.updateResult();
  }

  nextPage() {
    this.updateResult();
  }

  updateResult() {
    let dataUpdate = this.params.data;

    let param = {
      ...this.params,
      filter: {
        ...this.params.filter,
        dataFim: this.params.filter.dataFim.getTime(),
        dataInicio: this.params.filter.dataInicio.getTime(),
      },
    };

    this.laudoUnionService.getListaLaudosAgendados(param).then((r) => {
      if (dataUpdate == this.params.data) {
        this.total = r.total || 0;
        this.listaResultado = r.lista || [];
      }
    });
  }

  setSituacaoLaudo(situacaoLaudo) {
    this.params.filter.status = situacaoLaudo;
    this.updateResult();
  }

  setDataInicio(date, update = true) {
    date = this.params.filter.dataInicio.getTime();
    this.pesquisaDataInicio = date;
    if (update) this.updateResult();
  }

  setDataFim(date, update = true) {
    date = this.params.filter.dataFim.getTime();
    this.pesquisaDataFim = date;
    if (update) this.updateResult();
  }

  editarVistoriador(id, laudoId, placa){

      const modalRef = this.modalService.open(ModalEditarVistoriadorComponent, { centered: true });
      modalRef.componentInstance.cabecalho = 'Alterar vistoriador responsavel';
      modalRef.componentInstance.id = id;
      modalRef.result.then(vistoriador => {
        if (vistoriador) {
          let json = {
            vistoriadorId: vistoriador,
            laudoId: laudoId,
            placa: placa
          }
          this.laudoUnionService.salvarNovoVistoriador(json)
            .then((r) => {
              const objmodificado = this.listaResultado.filter(obj => obj.id == laudoId)
              for(let i=0; i<this.listaResultado.length; i++){
                if(this.listaResultado[i].id === objmodificado[0].id){
                  this.listaResultado[i].nomeusuario = r["nome"];
                }
              }
            })
            .catch(e => this.modalMsgService.openDialog('Erro ao atualizar vistoriador', '', 'danger'));
        }
      }).catch(e => this.modalMsgService.openDialog('Erro ao atualizar vistoriador',
        '', 'danger'));
  }

  editarDataAgendamento(id, placa){
    const modalRef = this.modalService.open(ModalEditarDataVistoriaComponent, { centered: true});
    modalRef.componentInstance.cabecalho = 'Alterar data do agendamento';
    modalRef.result.then(
      data => {
        if(data){
          let jsonData = {
            laudoId: id,
            placa : placa,
            dataAgendamento: this.formatDate(data.value.dataAgendamento),
            periodo: parseInt(data.controls.periodo.value),
          }
          this.laudoUnionService.atualizarDataAgendamento(jsonData)
          .then((r) => {
            const objmodificado = this.listaResultado.filter(obj => obj.id == jsonData.laudoId)
            for(let i=0; i<this.listaResultado.length; i++){
              if(this.listaResultado[i].id === objmodificado[0].id){
                this.listaResultado[i].dataagendamento = jsonData.dataAgendamento
                this.listaResultado[i].periodoagendamento = jsonData.periodo
              }
            }
          })
          .catch(e => this.modalMsgService.openDialog('Erro ao atualizar data', '', 'danger'))
        }
      }
    ).catch(e => this.modalMsgService.openDialog('Erro ao atualizar data',
    '', 'danger'))
  }

  cancelarAgendamento(laudoId, placa){
    this.modalMsgService.openDialogQuestion('ATENÇÃO !!!', 'Deseja realmente cancelar este agendamento ?').then(
      resposta => {
        if(resposta == 'ok'){
          this.laudoUnionService.cancelarAgendamento(laudoId, placa).then((r) =>{
            const objmodificado = this.listaResultado.filter(obj => obj.id == laudoId)
            for(let i=0; i<this.listaResultado.length; i++){
              if(this.listaResultado[i].id === objmodificado[0].id){
                this.listaResultado[i].status = 3
              }
            }

          })
          .catch(e => this.modalMsgService.openDialog('Erro ao cancelar agendamento', 'Caso problema persistir, favor entrar contato com o surpote.', 'danger'));
        }
      }).catch(e => this.modalMsgService.openDialog('Erro ao cancelar agendamento', 'Caso problema persistir, favor entrar contato com o surpote.', 'danger'));
  }

  verEndereco(cidade, uf, bairro, rua, numero, cep){
    var enderecoCompleto: string = rua + ', ' + numero + ' - ' + bairro + ', ' + cidade + '/' + uf + ' Cep: ' + cep;
    this.modalMsgService.openDialog('Endereço do agendamento', enderecoCompleto)
  }

  downloadExcel(){
    var laudosExcel = [];

    this.listaResultado.forEach(element => {
      laudosExcel.push({
        "ID": element.id,
        "Tipo Laudo": element.nometipolaudo,
        "Cliente": element.nomecliente ?? "PARTICULAR",
        "Unidade": element.nomeunidade,
        "Vistoriador": element.nomeusuario,
        "Placa": element.placa,
        "Agendado para": formatDate(element.dataagendamento, 'dd/MM/yyyy', this.locale),
        "Periodo": element.periodoagendamento == 0 ? " Manhã" : element.periodoagendamento == 1 ? " Tarde" : "",
        "Atualizado em": formatDate(element.dataultimaatualizacao, 'dd/MM/yyyy', this.locale),
        "Status": element.status == 2 ? "Agendado" : element.status == 3 ? "Cancelado" : "",
        "Confirmação do vist." : element.statusagendamento == 0 ? "Pendente" : element.statusagendamento == 1 ? "Confirmado" : element.statusagendamento == 2 ? "Rejeitado" :  "",
        "Cidade/Uf": element.cidade + "/" + element.uf,
        "Bairro": element.bairro,
        "Rua": element.rua + ", " + element.numero,
        "Cep": element.cep
      })
    });

    try{
      this.excelService.exportAsExcelFile(laudosExcel,
         `Laudos Agendados Union(${this.params.filter.status == '' ? "todos"
          : this.params.filter.status == '2' ? "Agendados"
          : this.params.filter.status == '3' ? "Cancelados"
          : ""})`
          );
    }catch{
      window.alert('Erro ao exportar arquivo')
    }
  }

  formatDate(date) {
    return new Date(
      date.year,
      date.month - 1,
      date.day,
      0, 0, 0, 0
    ).toISOString();
  }

}
